import {isEmpty} from 'ramda';

import type {Nullish} from 'shared/web';

import type {KanbanUser} from '../types/KanbanUser';

export function getKanbanUsersInBranches<
  TUser extends Pick<KanbanUser, 'id' | 'branches'> & {isHidden?: boolean},
>(users: TUser[], branchIds: string[], currentUserId: string | Nullish) {
  if (isEmpty(branchIds)) {
    return users;
  }

  const usersInBranches = users.filter(
    (user) =>
      user.id === currentUserId ||
      user.branches?.some((branch) => branchIds.includes(branch.id)) === true
  );

  if (usersInBranches.some((user) => user.isHidden !== true)) {
    return usersInBranches;
  }

  return usersInBranches.map((user) =>
    user.id === currentUserId ? {...user, isHidden: false} : user
  );
}
